import { Stream } from '@tempest/core';
export function drop(amount, stream) {
    return new Stream(new Drop(amount, stream.source));
}
class Drop {
    constructor(amount, source) {
        this.amount = amount;
        this.source = source;
    }
    run(sink, scheduler) {
        return new DropSink(this.amount, sink, this.source, scheduler);
    }
}
class DropSink {
    constructor(amount, sink, source, scheduler) {
        this.amount = amount;
        this.sink = sink;
        this.disposable = source.run(this, scheduler);
    }
    event(time, value) {
        if (--this.amount < 0) {
            this.sink.event(time, value);
        }
    }
    error(time, err) {
        this.sink.error(time, err);
    }
    end(time, value) {
        this.sink.end(time, value);
    }
    dispose() {
        return this.disposable.dispose();
    }
}
//# sourceMappingURL=index.js.map